<template>
  <div class="voucherSelect">
    <v-container>
      <v-card class="mx-auto" max-width="800" color="grey darken-2">
        <v-container>
          <h1 class="font-weight-light">{{title}}</h1>
          <v-row align-content-center>
            <v-col
              v-for="(voucher, index) in vouchers"
              :key="voucher.title"
              :index="index"
              class="mx-auto"
              sm="6"
              md="6"
              xs="12"
              lg="6"
              xl="6"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card class="mx-auto" color="grey lighten-4" max-width="600">
                  <v-img :aspect-ratio="16/9" :src="img" pa-3>
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out green v-card--reveal display-3 white--text"
                        style="height: 100%;"
                      >{{voucher.price}} €</div>
                    </v-expand-transition>
                  </v-img>
                  <v-card-text class="pt-6" style="position: relative;">
                    <v-btn
                      v-on:click="addVoucher(voucher.title, voucher.price, voucher.text, voucher.sku)"
                      absolute
                      color="green"
                      class="white--text"
                      fab
                      large
                      right
                      top
                      :disabled="disableButton"
                    >
                      <v-icon v-show="!hover">mdi-cart</v-icon>
                      <v-icon v-if="hover">mdi-cart-plus</v-icon>
                    </v-btn>
                    <div class="font-weight-light grey--text title mb-2">{{voucher.pitch}}</div>
                    <h3 class="display-1 font-weight-light green--text mb-2">{{voucher.title}}</h3>
                    <div class="font-weight-light grey--text darken-2 title mb-2">{{voucher.text}}</div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container v-if="showCart">
      <v-card class="mx-auto" max-width="800" color="grey darken-2">
        <v-container>
          <h1 class="font-weight-light">{{cartTitle}}</h1>
          <v-row align-content-center>
            <v-col class="mx-auto" sm="10" md="10" xs="12" lg="10" xl="10">
              <v-card class="mx-auto" color="grey lighten-4" max-width="600">
                <v-data-table
                  :headers="headers"
                  :items="selectedVouchers"
                  item-key="index"
                  light
                  hide-default-footer
                  disable-sort
                >
                  <template v-slot:item.action="{ item, index }">
                    <v-icon small @click="deleteItem(index)">mdi-delete</v-icon>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <v-container v-if="showCart">
      <v-card class="mx-auto" max-width="800" color="grey darken-2">
        <v-container>
          <v-row align-content-center no-gutters>
            <v-col class="mx-auto" sm="10" md="10" xs="12" lg="10" xl="10">
              <div>
                <h2 class="text-center font-weight-light">
                  {{checkoutText}}
                  <br />
                  <b>{{checkoutSum}} {{currencySymbol}}</b>
                </h2>
              </div>

              <div>
                <vue-stripe-checkout
                  ref="checkoutRef"
                  :items="items"
                  :successUrl="successUrl"
                  :cancelUrl="cancelUrl"
                >
                  <template slot="checkout-button">
                    <v-btn
                      @click="triggerStripePayment()"
                      block
                      color="green"
                      dark
                    >{{checkoutButton}}</v-btn>
                  </template>
                </vue-stripe-checkout>
              </div>
              <br />

              <div>
                <PayPal
                  currency="EUR"
                  :client="credentials"
                  :amount="checkoutSum"
                  :items="items"
                  :button-style="buttonStyle"
                  env="production"
                ></PayPal>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>
                

<script>
import { db } from "../firebase";
import PayPal from "vue-paypal-checkout";

export default {
  data() {
    return {
      //Table scripts

      headers: [
        { text: "Artikel", align: "left", value: "title" },
        { text: "Anzahl", value: "amount" },
        { text: "Preis €", value: "price" },
        { text: "Entfernen", value: "action" }
      ],

      selectedVouchers: [],

      disableButton: false,
      
      

      //Stripe Stuff
      items: [],
      /* cartItems: selectedVouchers.map(x => ({
        sku: x.sku,
        quantity: x.amount
      })),*/
      successUrl: "https://bodensee-buggy-by-max.web.app/payment/success",
      cancelUrl: "https://bodensee-buggy-by-max.web.app/payment/failed",

      //Page script and load Items
      showCart: false,
      overlay: true,
      title: "Wähle deinen Gutschein",
      img: "/img/gift-card.svg",

      cartTitle: "Warenkorb",

      //Button to Checkout
      checkoutButton: "weiter zur Bezahlung",
      //Checkout Sum
      checkoutText: "Summe: ",
      currencySymbol: "€",

      vouchers: [],
      ref: db.collection("voucher"),

      //Paypal Stuff
      credentials: {
        sandbox:
          "Af7O0kakqg9n-FrdgnlA806PlyxUh2NC49nTo-_k-85vzBTW5icrVjVPXfVR0D274JxpWFRs0QyRnGQn",
        production: "AdSiO_VLbYJsqbIBRQfs80hyk8JRcznxDbpMJTXO9PRlrmzCMDHI2Q6op_lZf98OmAmg1IPQsUx5PwEh"
      },
      //Paypal Button looks
      buttonStyle: {
        size: "responsive",
        shape: "rect",
        tagline: false,
        height: 36
      }
    };
  },

  components: {
    PayPal
  },

  computed: {
    checkoutSum: function(selectedVouchers) {
      var sum = 0;

      for (let i = 0; i < this.selectedVouchers.length; i++) {
        sum += this.selectedVouchers[i].price;
      }
      return sum.toString();
    },
  },

  created() {
    this.ref.onSnapshot(querySnapshot => {
      this.vouchers = [];
      this.overlay = false;
      querySnapshot.forEach(doc => {
        this.vouchers.push({
          title: doc.data().name,
          text: doc.data().description,
          pitch: doc.data().subtitle,
          price: doc.data().price,
          sku: doc.data().sku
        });
      });
    });
  },

  methods: {

    

    async generatePaypalItems() {
      this.items = this.selectedVouchers.map(item => {
        return {
          quantity: item.amount,
          price: item.price,
          description: item.description,
          name: item.title,
          currency: "EUR"
        };
      });
      console.log(this.items);
    },

    async generateStripeItems() {
      this.items = this.selectedVouchers.map(item => {
        return {
          sku: item.sku,
          quantity: item.amount
        };
      });
      console.log(this.items);
    },

    async triggerStripePayment() {
      await this.generateStripeItems();
      this.$refs.checkoutRef.redirectToCheckout();
    },

    deleteItem(index) {
      this.disableButton = false;

      this.selectedVouchers.splice(this.index, 1);

      if (this.selectedVouchers.length == 0) {
        this.showCart = false;
      }
    },

    addVoucher(name, price, text, sku, selectedVouchers, checkoutSum) {
      this.showCart = true;
      //Add Select
      var present = false;
      this.disableButton = true;

      //Check if Voucher is already selected
      for (let i = 0; i < this.selectedVouchers.length; i++) {
        if (this.selectedVouchers[i].title === name) {
          this.selectedVouchers[i].amount++;
          this.selectedVouchers[i].price =
            this.selectedVouchers[i].price + price;
          present = true;
        }
      }

      if (!present) {
        this.selectedVouchers.push({
          title: name,
          description: text,
          price: price,
          amount: 1,
          sku: sku
        });
      }

       


    }
  }
};
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}
</style>
